export const BASE_NAME = "";
export const IMAGE_URL = `${BASE_NAME}/assets/images`;
export const ENVIRONMENT = process.env.REACT_APP_ENV || "development";
